var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 8.14692C14.3002 9.96946 12.8227 11.4469 11.0002 11.4469C9.17765 11.4469 7.70019 9.96946 7.70019 8.14692M4.33353 19.6969H17.6669C18.8451 19.6969 19.8002 18.7595 19.8002 17.6032L18.4335 5.39689C18.4335 4.24058 17.4784 3.30321 16.3002 3.30321H5.43353C4.25532 3.30321 3.3002 4.24058 3.3002 5.39689L2.2002 17.6032C2.2002 18.7595 3.15532 19.6969 4.33353 19.6969Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.881e035c69c6925aa92ac70587c1dd99.svg";
export { ForwardRef as ReactComponent };